<div class="ui-autocomplete-field">
  @if (label()) {
    <label class="ui-autocomplete-field__label" [attr.for]="label() || null">
      {{ label() | uiLabelTranslate }}
      @if (required()) {
        <span class="ui-autocomplete-field__required">*</span>
      }
    </label>
  }

  <div class="ui-autocomplete-field__panel">
    <p-autoComplete
      [inputId]="label() || undefined"
      [ngModel]="value()"
      [placeholder]="placeholder() | uiLabelTranslate"
      [readonly]="readonly()"
      [disabled]="disabled()"
      [required]="required()"
      [suggestions]="resolvedOptions()"
      [optionLabel]="'translatedLabel'"
      [minLength]="minSearchLength()"
      [delay]="0"
      [showEmptyMessage]="showEmptyState()"
      [emptyMessage]="emptyMessage() | uiLabelTranslate"
      [appendTo]="'body'"
      [dropdown]="false"
      [completeOnFocus]="options().length > 0"
      [inputStyleClass]="'ui-autocomplete-field__control'"
      [panelStyleClass]="'ui-autocomplete-field__menu'"
      (ngModelChange)="onValueChange($event)"
      (onSelect)="onSelect($event)"
    >
      <ng-template let-option #item>
        <div class="ui-autocomplete-field__option">
          <span class="ui-autocomplete-field__option-label">{{ option.translatedLabel }}</span>
          @if (option.translatedCaption) {
            <span class="ui-autocomplete-field__option-caption">{{ option.translatedCaption }}</span>
          }
        </div>
      </ng-template>
    </p-autoComplete>
  </div>

  @if (error()) {
    <p class="ui-autocomplete-field__error">{{ error() | uiLabelTranslate }}</p>
  } @else if (hint()) {
    <p class="ui-autocomplete-field__hint">{{ hint() | uiLabelTranslate }}</p>
  }
</div>
